//transak url
export const transakUrl = 'https://staging-global.transak.com/?apiKey=5aed5b3c-fbce-45ec-a62b-f835254ea9f9'

//covalent api host
export const covalentApiHost = 'https://api.covalenthq.com'
//covalent api key
export const covalentApiKey = 'ckey_c6e3dad6bbed4224bdb769673a9'

//ceramic host
export const CeramicApiHost = 'https://ceramic.passport-iam.gitcoin.co';

//swarm ts-tar metafile name
export const META_FILE_NAME = '.swarmgatewaymeta.json';

//web3 storage url
export const web3StorageHost = 'https://api.web3.storage';

//web3 storage appkey
export const web3StorageAppKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEJlY0Q2MDVmZGZiNWVFRTdhYUZlYmVhNzUxMjVCMDBCNDkzMDMxOUUiLCJpc3MiOiJ3ZWIzLXN0b3JhZ2UiLCJpYXQiOjE2NTEzNjE4MTAwNDIsIm5hbWUiOiJ0ZXN0In0.SqcXP8E9fJEQ_7AGjrHaliBsoKCl2l2mA2q1-Lejkp4';

//web3 gateway
export const web3Gateway = "https://dweb.link/ipfs/"

//swarm api getway for download files from swarm
export const swarmGateway = "https://api.gateway.ethswarm.org/bzz/";

//swarm api gateway for upload files to swarm
export const swarmGatewayList = [
  "https://gateway-proxy-bee-0-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-1-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-2-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-3-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-4-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-5-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-6-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-7-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-8-0.gateway.ethswarm.org/bzz",
  "https://gateway-proxy-bee-9-0.gateway.ethswarm.org/bzz"
];
//arweave mainnet url
export const arweaveUrl = "https://arweave.net/";

//arweave testnet url
export const arweaveTestUrl = "https://arweave.net/";

//boba mainnet url
export const bundlrUrl = "https://node1.bundlr.network";

//boba testnet url
export const bundlrTestUrl = "https://devnet.bundlr.network";

//boba toekn testnet contract address 
export const bobaTestContractAddress = "0xF5B97a4860c1D81A1e915C40EcCB5E4a5E6b8309";

//green dao contract address
export const greenDaoContractAddress = {
  4: "0x23fFb93fA95FA1234C6eB5d09C269DC9645eB5d3",
  5: "0x88013788939E2E0ffA612cEBb572C36b677FdA75",
  50: "0x5Fa8EC162cbd693418F7DC1361c002a0A18aa684",
  2828: '0x67E843E19F82f0367105e1CB47E0608a6cbCD1c6',
  80001: "0x7a14d82Dd58681a69dc1949cDDeE10c591C193E3",
};

//green vote contract address
export const greenVoteContractAddress = {
  4: "0x210dC51c17d3E76D4831f1d701e52FA3eace2477",
  5: "0xE24f5a927A7502Bf85766873A6D0D149b2b69755",
  50: "0xC8ee8f35568851e8b886569E40B6cd35dE944fe3",
  2828: '0x3F0298D5D908cAAe25F87096582cF4De3eDf4E3A',
  80001: "0xAfDFc17A327269d1aDeE4E737CA6b91B669ddfa8",
};

//green auction contract address
export const greenAuctionContractAddress = {
  4: "0x90a9B5FD86D2A373BC1D6786f12f086B9F82F372",
  5: "0x250F881751805c169605aC2A95eF84ddf3cb87b7",
  50: "0x850cb8117336eeeF5AA2eAE8623843A821725Ac7",
  2828: '0xcc477D30287A3f27f9c70A57f71De9caA0b49c09',
  80001: "0x2cEaB43754E3d27cF6B965d75167656a988fB59C",
};

//green grant contract address
export const greenGrantContractAddress = {
  4: "0xa70386D4291fD2A3640Ff9E692Fe5354E0016cCe",  
  5: "0x23c2cFb2B9cc9C68c7a91f1a017b7162446F3F54",
  50: "0x6D1C85d3d4f26C5842e2f62B341d6f743561cb90",
  2828: '0x052a185E581514344657a4bDF3500865f5520503',
  80001: "0x7823Fd479e19569647B38449fe2A8AA1061Fef34",
};

//green learning contract address
export const greenLearningContractAddress = {
  4: "0x9386EFeCCa5d0d9Cb7aDd2404F8130351d4e5d61",
  5: "0xF6A9b8A3aFB714478996D418E6AD75e23C0FA7E6",
  50: "0xc8814e6358Cc29938DC47b5a1A0e417F3C9B3FF4",
  2828: '0xcC5E3F778D10b0dA5a8cA99d312798188c120F1a',
  80001: "0xE6630439f0C0f2446092FfD1a2dd5FC623713E22",
};

//green chat contract address
export const greenChatContractAddress = {
  4: "0x70ee0B3123ec846eD7bb71b1E233a09458D47F2c",
  5: "0xa49f29884d40e17ca2108D3367359a61ddb8E369",
  50: "0x1de8d4Bc27a8B9baB9b90c8561277B09f9cbf4BC",
  2828: '0x9aD8d42FF933F684aa64455d4f18E20F24a4a5C2',
  80001: "0x62c87Ba81268B5A77cBb9356813aC35302DfB8cf",
}

//token List
export const tokenList = {
  1: ['ETH'],
  3: ['ETH'],
  4: ['ETH'],
  5: ['ETH'],
  10: ['ETH'],
  28: ['BOBA', 'ETH'],
  42: ['ETH'],
  50: ['XDC'],  
  56: ['BNB'],
  66: ['OKT'],  
  82: ['MTR'],
  83: ['MTR'],
  100: ['xDAI'],
  128: ['HT'],
  137: ['MATIC'],  
  250: ['FTM'],
  288: ['BOBA', 'ETH'],
  588: ['METIS', 'ETH'],
  1088: ['METIS', 'ETH'],
  2828: ['LYXT'],
  4689: ['IOTX'],
  42161: ['ETH'],
  43114: ['AVAX'],
  80001: ['MATIC'],
};

//chain list
export const chainList = [
  {
    chainId: 1,
    chainName: 'Ethereum Chain Mainnet',
    nativeCurrency: 'ETH',
    rpcUrls: "https://mainnet.infura.io/v3",
    blockExplorerUrls: "https://etherscan.io",
  },
  {
    chainId: 3,
    chainName: 'Ropsten Chain Testnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://ropsten.infura.io/v3',
    blockExplorerUrls: 'https://ropsten.etherscan.io',
  },
  {
    chainId: 4,
    chainName: 'Rinkeby Chain Testnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://rinkeby.infura.io/v3',
    blockExplorerUrls: 'https://rinkeby.etherscan.io',
  },
  {
    chainId: 5,
    chainName: 'Goerli Chain Testnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://goerli.infura.io/v3',
    blockExplorerUrls: 'https://goerli.etherscan.io',
  },
  {
    chainId: 10,
    chainName: 'Optimistic Chain Mainnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://mainnet.optimism.io',
    blockExplorerUrls: 'https://optimism.io',
  },  
  {
    chainId: 28,
    chainName: 'Boba Chain Testnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://rinkeby.boba.network',
    blockExplorerUrls: 'https://blockexplorer.rinkeby.boba.network',
  },    
  {
    chainId: 42,
    chainName: 'Kovan Chain Testnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://kovan.infura.io/v3',
    blockExplorerUrls: 'https://kovan.etherscan.io',
  },
  {
    chainId: 50,
    chainName: 'XDC Chain Mainnet',
    nativeCurrency: 'XDC',
    rpcUrls: 'https://rpc.xinfin.network',
    blockExplorerUrls: 'https://explorer.xinfin.network',
  },  
  {
    chainId: 56,
    chainName: 'BSC Chain Mainnet',
    nativeCurrency: 'BNB',
    rpcUrls: 'https://bsc-dataseed.binance.org',
    blockExplorerUrls: 'https://bscscan.com',
  },
  {
    chainId: 66,
    chainName: 'OKEx Chain Mainnet',
    nativeCurrency: 'OKT',
    rpcUrls: 'https://exchainrpc.okex.org',
    blockExplorerUrls: 'https://www.oklink.com/okexchain',
  },  
  {
    chainId: 82,
    chainName: 'Meter Chain Mainnet',
    nativeCurrency: 'MTR',
    rpcUrls: 'https://rpc.meter.io',
    blockExplorerUrls: 'https://scan.meter.io',
  },  
  {
    chainId: 83,
    chainName: 'Meter Chain Testnet',
    nativeCurrency: 'MTR',
    rpcUrls: 'https://rpctest.meter.io',
    blockExplorerUrls: 'https://scan-warringstakes.meter.io',
  },      
  {
    chainId: 100,
    chainName: "Gnosis Chain Mainnet",
    nativeCurrency: "xDAI",
    rpcUrls: 'https://rpc.xdaichain.com',
    blockExplorerUrls: 'https://blockscout.com/poa/xdai',
  },
  {
    chainId: 128,
    chainName: 'Heco Chain Mainnet',
    nativeCurrency: 'HT',
    rpcUrls: 'https://http-mainnet-node.huobichain.com',
    blockExplorerUrls: 'https://hecoinfo.com',
  },
  {
    chainId: 137,
    chainName: 'Polygon Chain Mainnet',
    nativeCurrency: 'MATIC',
    rpcUrls: 'https://rpc-mainnet.matic.network',
    blockExplorerUrls: 'https://polygonscan.com',
  },  
  {
    chainId: 250,
    chainName: 'Fantom Chain Mainnet',
    nativeCurrency: 'FTM',
    rpcUrls: 'https://rpc.ftm.tools',
    blockExplorerUrls: 'https://ftmscan.com',    
  },  
  {
    chainId: 288,
    chainName: 'Boba Chain Mainnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://mainnet.boba.network',
    blockExplorerUrls: 'https://blockexplorer.boba.network',
  },
  {
    chainId: 588,
    chainName: 'Metis Stardust Testnet',
    nativeCurrency: 'METIS',
    rpcUrls: 'https://stardust.metis.io/?owner=588',
    blockExplorerUrls: 'https://stardust-explorer.metis.io',
  },
  {
    chainId: 1088,
    chainName: 'Metis Andromeda Mainnet',
    nativeCurrency: 'METIS',
    rpcUrls: 'https://andromeda.metis.io/?owner=1088',
    blockExplorerUrls: 'https://andromeda-explorer.metis.io',
  },    
  {
    chainId: 2828,
    chainName: 'KUKSO Test network',
    nativeCurrency: 'LYXT',
    rpcUrls: 'https://rpc.l16.lukso.network',
    blockExplorerUrls: 'https://explorer.execution.l16.lukso.network',
  },
  {
    chainId: 4689,
    chainName: 'IoTex Chain Mainnet',
    nativeCurrency: 'IOTX',
    rpcUrls: 'https://babel-api.mainnet.iotex.io',
    blockExplorerUrls: 'https://iotexscan.io',
  },  
  {
    chainId: 42161,
    chainName: 'Arbitrum Chain Mainnet',
    nativeCurrency: 'ETH',
    rpcUrls: 'https://arb1.arbitrum.io/rpc',
    blockExplorerUrls: 'https://arbiscan.io',
  },  
  {
    chainId: 43114,
    chainName: 'AVAX Chain Mainnet',
    nativeCurrency: 'AVAX',
    rpcUrls: 'https://api.avax.network/ext/bc/C/rpc',
    blockExplorerUrls: 'https://cchain.explorer.avax.network',
  },
  {
    chainId: 80001,
    chainName: 'Polygon Mumbai Testnet',
    nativeCurrency: 'MATIC',
    rpcUrls: 'https://matic-mumbai.chainstacklabs.com',
    blockExplorerUrls: 'https://mumbai.polygonscan.com',
  },  
];